// StartCustomCode - Delivery estimate widget
(function () {
  'use strict';

  var STORAGE_KEY = 'ohclocks_delivery_location';
  var WORKER_URL = '';
  var AUTO_TTL_MS = 30 * 24 * 60 * 60 * 1000; // auto-detected locations expire after 30 days
  var activeAbortController = null;
  var requestSeq = 0;

  // Shrinks the "to [chip] Change" cluster to fit the cart widget's actual
  // width, instead of wrapping. Container width doesn't track viewport width
  // (sidebar vs. full-width drawer), so a CSS vw-based clamp can't do this -
  // it has to be measured against the real element.
  function fitCartLocGroup(container) {
    var el = container.querySelector('.de__loc-group');
    if (!el) return;
    var maxSize = 15;
    var minSize = 11;
    var available = container.clientWidth;
    if (!available) return;
    var size = maxSize;
    el.style.fontSize = size + 'px';
    while (el.getBoundingClientRect().width > available && size > minSize) {
      size -= 0.5;
      el.style.fontSize = size + 'px';
    }
  }

  function getSavedLocation() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      var loc = JSON.parse(raw);
      // Auto-detected (IP) locations expire; manual selections never do.
      if (loc && loc.auto && (!loc.savedAt || Date.now() - loc.savedAt > AUTO_TTL_MS)) {
        localStorage.removeItem(STORAGE_KEY);
        return null;
      }
      return loc;
    } catch (e) {
      return null;
    }
  }

  function saveLocation(loc, isAuto) {
    try {
      var toStore = loc;
      if (isAuto) {
        toStore = { suburb: loc.suburb, state: loc.state, postcode: loc.postcode, country: loc.country, auto: true, savedAt: Date.now() };
      }
      localStorage.setItem(STORAGE_KEY, JSON.stringify(toStore));
    } catch (e) { /* ignore */ }
  }

  var SAME_DAY_VENDORS = ['one six eight london', 'toki', 'clocksicle'];

  var STATIC_FALLBACK = {
    AU: [{ serviceName: 'Standard', description: 'Metro: 2–6 business days<br>Regional: 5–10 business days', isFree: true, priceDollars: '0', hideFallbackPrice: true }],
    NZ: [{ serviceName: 'Standard', description: '6–10 business days', isFree: true, priceDollars: '0', hideFallbackPrice: true }]
  };
  var FALLBACK_NOTE_AU = 'Express shipping and final delivery estimates shown at checkout';
  var FALLBACK_NOTE_NZ = 'Final delivery estimate shown at checkout';

  function getFallbackRates(country) {
    return STATIC_FALLBACK[country] || STATIC_FALLBACK.AU;
  }

  function show(el) { if (el) el.hidden = false; }
  function hide(el) { if (el) el.hidden = true; }

  function showState(widget, state) {
    hide(widget.querySelector('[data-de-prompt]'));
    hide(widget.querySelector('[data-de-result]'));
    hide(widget.querySelector('[data-de-loading]'));
    hide(widget.querySelector('[data-de-error]'));
    show(widget.querySelector('[data-de-' + state + ']'));
  }

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.textContent = str;
    return div.innerHTML;
  }

  // ── Quote fetch (longer timeout + one retry) + PDP result cache ──

  var QUOTE_TIMEOUT_MS = 8000;              // was 5000 — don't fall back on a merely-slow response
  var RESULT_CACHE_PREFIX = 'ohclocks_de_pdp_';

  // POST a quote; retry once on timeout/error/5xx before giving up. cb(data) or cb(null).
  function fetchQuote(url, payload, cb) {
    var attempts = 0;
    function attempt() {
      attempts++;
      var abort = new AbortController();
      var timer = setTimeout(function () { abort.abort(); }, QUOTE_TIMEOUT_MS);
      fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
        signal: abort.signal
      })
        .then(function (r) {
          clearTimeout(timer);
          if (!r.ok) throw new Error('http ' + r.status);
          return r.json();
        })
        .then(function (data) { cb(data); })
        .catch(function () {
          clearTimeout(timer);
          if (attempts < 2) { attempt(); } else { cb(null); }
        });
    }
    attempt();
  }

  function localDayKey(d) {
    return d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate();
  }

  // PDP estimates are cached per variant + location + currency, scoped to the
  // local day (delivery dates roll over daily / at dispatch cutoffs). A same-day
  // cache is shown instantly and then revalidated from the Worker in the
  // background, so refresh/revisit is instant without risking stale dates.
  function pdpCacheKey(variantId, location, currency) {
    return RESULT_CACHE_PREFIX + variantId + '|' + (location.postcode || '') + '|' + (location.country || '') + '|' + currency;
  }

  function getCachedPdpResult(key) {
    try {
      var raw = localStorage.getItem(key);
      if (!raw) return null;
      var entry = JSON.parse(raw);
      if (!entry || !entry.data) return null;
      if (entry.day !== localDayKey(new Date())) { localStorage.removeItem(key); return null; }
      return entry.data;
    } catch (e) { return null; }
  }

  function setCachedPdpResult(key, data) {
    try {
      localStorage.setItem(key, JSON.stringify({ data: data, day: localDayKey(new Date()) }));
    } catch (e) { /* ignore quota errors */ }
  }

  // ── IP geolocation (via Cloudflare Worker /geo, validated server-side) ──

  function detectLocation(cb) {
    if (!WORKER_URL) { cb(null); return; }
    var abort = new AbortController();
    var timeout = setTimeout(function () { abort.abort(); }, 2000);
    fetch(WORKER_URL + '/geo', { signal: abort.signal })
      .then(function (r) { return r.json(); })
      .then(function (loc) {
        clearTimeout(timeout);
        if (loc && loc.suburb && loc.postcode && loc.country) {
          cb(loc);
        } else {
          cb(null);
        }
      })
      .catch(function () { clearTimeout(timeout); cb(null); });
  }

  // ── Delivery date formatting ──
  // Worker returns e.g. "estimated Fri 17 Jul - Mon 20 Jul". We relabel to
  // "Expected delivery" and collapse a shared month ("Fri 17 - Mon 20 Jul").
  // Fallback strings (e.g. "Metro: 2–6 business days") are passed through as raw.

  function formatDeliveryDate(description) {
    var desc = (description || '').trim();
    if (!/^estimated\b/i.test(desc)) {
      return { raw: description || '' };
    }
    var body = desc.replace(/^estimated\s+/i, '');
    var parts = body.split(' - ');
    if (parts.length !== 2) {
      return { label: 'Expected delivery', range: body };
    }
    var a = parts[0].trim().split(/\s+/); // [dow, day, mon]
    var b = parts[1].trim().split(/\s+/);
    var range;
    if (a.length === 3 && b.length === 3 && a[2] === b[2]) {
      // same month → show month once on the second date only
      range = a[0] + ' ' + a[1] + ' - ' + b[0] + ' ' + b[1] + ' ' + b[2];
    } else {
      range = parts[0].trim() + ' - ' + parts[1].trim();
    }
    return { label: 'Expected delivery', range: range };
  }

  // Build the two-line "when" markup from a rate description.
  function buildWhenHtml(description) {
    var f = formatDeliveryDate(description);
    if (f.raw !== undefined) {
      return '<div class="de__rate-when de__rate-when--raw">' + escapeHtml(f.raw) + '</div>';
    }
    return '<div class="de__rate-when">' +
      '<span class="de__exp">' + f.label + '</span> ' +
      '<span class="de__range">' + escapeHtml(f.range) + '</span></div>';
  }

  // ── Autocomplete ──

  function fetchSuggestions(query, callback) {
    if (query.length < 2 || !WORKER_URL) { callback([]); return; }

    if (activeAbortController) activeAbortController.abort();
    activeAbortController = new AbortController();
    var seq = ++requestSeq;
    var signal = activeAbortController.signal;

    var timeout = setTimeout(function () { activeAbortController.abort(); }, 5000);

    fetch(WORKER_URL + '/suburbs?q=' + encodeURIComponent(query), { signal: signal })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        clearTimeout(timeout);
        if (seq === requestSeq) callback(data || []);
      })
      .catch(function () { clearTimeout(timeout); });
  }

  function renderSuggestions(list, suggestions, onSelect) {
    list.innerHTML = '';
    if (!suggestions.length) { hide(list); return; }

    suggestions.forEach(function (s) {
      var li = document.createElement('li');
      li.className = 'de__suggestion';
      li.setAttribute('role', 'option');
      li.textContent = s.suburb + ', ' + s.state + ' ' + s.postcode + (s.country === 'NZ' ? ' NZ' : '');
      li.addEventListener('click', function () {
        onSelect(s);
        hide(list);
      });
      list.appendChild(li);
    });
    show(list);
  }

  function setupAutocomplete(container, onSelect) {
    var input = container.querySelector('[data-de-input]');
    var list = container.querySelector('[data-de-suggestions]');
    if (!input || !list) return;

    var debounceTimer = null;
    input.addEventListener('input', function () {
      var q = input.value.trim();
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(function () {
        fetchSuggestions(q, function (results) {
          renderSuggestions(list, results, function (loc) {
            input.value = loc.suburb + ' ' + loc.state + ' ' + loc.postcode;
            onSelect(loc);
          });
        });
      }, 250);
    });

    input.addEventListener('keydown', function (e) {
      var items = list.querySelectorAll('.de__suggestion');
      var current = list.querySelector('[aria-selected="true"]');
      var idx = Array.prototype.indexOf.call(items, current);

      if (e.key === 'ArrowDown') {
        e.preventDefault();
        if (current) current.removeAttribute('aria-selected');
        var next = items[idx + 1] || items[0];
        if (next) next.setAttribute('aria-selected', 'true');
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        if (current) current.removeAttribute('aria-selected');
        var prev = items[idx - 1] || items[items.length - 1];
        if (prev) prev.setAttribute('aria-selected', 'true');
      } else if (e.key === 'Enter') {
        e.preventDefault();
        if (current) current.click();
      } else if (e.key === 'Escape') {
        hide(list);
      }
    });

    document.addEventListener('click', function (e) {
      if (!container.contains(e.target)) hide(list);
    });
  }

  // ── Rate row rendering (shared two-line layout, PDP + cart) ──

  // Pre-order caveat (cart only).
  // A PDP for a pre-order vendor renders no widget at all (delivery-estimate.liquid), and neither
  // does an all-pre-order cart — the quote is transit-only and assumes we ship today, so it would
  // promise delivery before the dispatch date. A MIXED cart still shows the estimate, because it's
  // accurate for the rest of the order, but has to say what it doesn't cover. Deliberately names no
  // date: each line already shows its own, and different vendors can be on different dates.
  // Flagged by data-has-preorder, set in Liquid from snippets/preorder.date.liquid.
  function preorderNoteHtml(el, cls) {
    if (!el || !el.getAttribute('data-has-preorder')) return '';
    return '<div class="' + cls + '">Excludes pre-order items — see the dispatch date on each item</div>';
  }

  function sortRates(rates) {
    return rates.slice().sort(function (a, b) {
      var aExp = a.serviceName.toLowerCase().indexOf('express') !== -1 ? 1 : 0;
      var bExp = b.serviceName.toLowerCase().indexOf('express') !== -1 ? 1 : 0;
      return aExp - bExp;
    });
  }

  // One rate → two-line block: "service (+ express price)" over "Expected delivery <range>".
  // Standard shows no price (its name already says "Free"); Express shows price beside the name.
  //
  // A combined rate that spans both tiers (e.g. Bespoke's checkout-style "Express + Standard"
  // merge for a mixed NZ cart, see Bespoke macro rate_6myipu1mc / blendGroupRates fallback in
  // the Worker) mentions both words — treat that as standard/mixed, not pure express, so we
  // don't over-promise "Free express delivery" when only part of the cart actually qualifies.
  function buildRateHtml(rate) {
    var name = rate.serviceName.toLowerCase();
    var hasExpress = name.indexOf('express') !== -1;
    var hasStandard = name.indexOf('standard') !== -1;
    var isExpress = hasExpress && !hasStandard;
    var isMixed = hasExpress && hasStandard;
    var serviceName = isMixed
      ? (rate.isFree ? 'Free standard + express delivery' : 'Standard + express delivery')
      : isExpress
        ? (rate.isFree ? 'Free express delivery' : 'Express delivery')
        : 'Free standard delivery';
    var priceHtml = (isExpress && !rate.isFree) ? '<span class="de__price">$' + escapeHtml(rate.priceDollars) + '</span>' : '';

    return '<div class="de__rate">' +
      '<div class="de__rate-head">' +
        '<span class="de__service">' + serviceName + '</span>' + priceHtml +
      '</div>' +
      (rate.description ? buildWhenHtml(rate.description) : '') +
      '</div>';
  }

  function buildRateRowsHtml(rates, country) {
    var html = '';
    var hasStandard = false;
    var hasExpress = false;
    var isFallback = false;

    sortRates(rates).forEach(function (rate) {
      var isExpress = rate.serviceName.toLowerCase().indexOf('express') !== -1;
      if (rate.hideFallbackPrice) isFallback = true;
      if (isExpress) hasExpress = true;
      else hasStandard = true;
      html += buildRateHtml(rate);
    });

    if (!isFallback && hasStandard && !hasExpress && country !== 'NZ') {
      html += '<div class="de__rate de__rate--unavailable">' +
        '<span class="de__service">Express delivery isn\'t available to this postcode.</span></div>';
    }

    return html;
  }

  // ── PDP logic ──

  function initPdp(widget) {
    WORKER_URL = widget.dataset.workerUrl || WORKER_URL;
    var jadcoSpecialSkus = ['BQ1700', 'BQ20', 'BQ368', 'MQ100-12HR', 'MQ100-24HR', 'R100-12HR', 'R100-24HR'];
    var dispatchNote = widget.querySelector('[data-de-dispatch]');

    function getItemData() {
      var sku = widget.dataset.sku || '';
      var inventoryQty = parseInt(widget.dataset.inventoryQuantity, 10) || 0;
      var inventoryPolicy = widget.dataset.inventoryPolicy || '';
      var outOfStock = inventoryPolicy === 'continue' && inventoryQty < 1 && jadcoSpecialSkus.indexOf(sku) !== -1;

      return {
        name: widget.dataset.title || '',
        sku: sku,
        quantity: 1,
        grams: parseInt(widget.dataset.grams, 10) || 0,
        price: parseInt(widget.dataset.price, 10) || 0,
        vendor: widget.dataset.vendor || '',
        product_id: parseInt(widget.dataset.productId, 10) || 0,
        variant_id: parseInt(widget.dataset.variantId, 10) || 0,
        out_of_stock: outOfStock
      };
    }

    function qualifiesForSameDay() {
      var vendor = (widget.dataset.vendor || '').toLowerCase();
      var qty = parseInt(widget.dataset.inventoryQuantity, 10) || 0;
      if (SAME_DAY_VENDORS.indexOf(vendor) === -1) return false;
      if (qty < 1) return false;
      return true;
    }

    function updateDispatchNote(parentSelector) {
      if (!dispatchNote) return;
      if (!qualifiesForSameDay()) {
        hide(dispatchNote);
        widget.classList.remove('delivery-estimate--same-day');
        return;
      }
      var parent = widget.querySelector(parentSelector);
      if (parent) parent.appendChild(dispatchNote);
      show(dispatchNote);
      widget.classList.add('delivery-estimate--same-day');
    }

    function setupResultHeading(location) {
      var heading = widget.querySelector('[data-de-heading]');
      var chipLabel = escapeHtml(location.suburb) + ' ' +
        escapeHtml(location.state) + ' ' + escapeHtml(location.postcode) +
        (location.country === 'NZ' ? ' NZ' : '');
      heading.innerHTML = '<span class="de__heading-emphasis">FREE Shipping</span> ' +
        '<span class="de__loc-group">to ' +
        '<button type="button" class="de__chip" data-de-edit-inline>' + chipLabel + '</button> ' +
        '<button type="button" class="de__edit-link" data-de-edit-inline>Change</button></span>';
      var editBtns = heading.querySelectorAll('[data-de-edit-inline]');
      for (var i = 0; i < editBtns.length; i++) {
        editBtns[i].addEventListener('click', function () {
          showState(widget, 'prompt');
          updateDispatchNote('[data-de-prompt]');
          var input = widget.querySelector('[data-de-input]');
          if (input) { input.value = ''; input.focus(); }
        });
      }
    }

    function showFallback(location) {
      var ratesEl = widget.querySelector('[data-de-rates]');
      var country = location.country || 'AU';
      setupResultHeading(location);
      var note = country === 'NZ' ? FALLBACK_NOTE_NZ : FALLBACK_NOTE_AU;
      var fallback = STATIC_FALLBACK[country] || STATIC_FALLBACK.AU;
      var desc = fallback[0].description.replace(/<br>/g, '\n').split('\n');
      var html = '<div class="de__fallback-lines">';
      desc.forEach(function (line) { html += '<div class="de__fallback-line">' + line + '</div>'; });
      html += '</div>';
      html += '<div class="de__fallback-note">' + note + '</div>';
      ratesEl.innerHTML = html;
      showState(widget, 'result');
    }

    function renderPdpResult(data, location) {
      var ratesEl = widget.querySelector('[data-de-rates]');
      setupResultHeading(location);

      if (data.specialOrder) {
        ratesEl.innerHTML = '<div class="de__special-order">' + escapeHtml(data.message) + '</div>';
        showState(widget, 'result');
        return;
      }

      ratesEl.innerHTML = '<div class="de__rates">' + buildRateRowsHtml(data.rates, location.country) + '</div>';
      showState(widget, 'result');
      updateDispatchNote('[data-de-result]');
    }

    function fetchEstimate(location) {
      var currency = widget.dataset.currency || 'AUD';
      var cacheK = pdpCacheKey(widget.dataset.variantId, location, currency);
      var cachedData = getCachedPdpResult(cacheK);

      if (cachedData) {
        renderPdpResult(cachedData, location);   // instant paint from cache
      } else {
        showState(widget, 'loading');
        hide(dispatchNote);
      }

      var payload = {
        destination: {
          country: location.country || 'AU',
          postal_code: location.postcode,
          province: location.state || '',
          city: location.suburb || ''
        },
        item: getItemData(),
        currency: currency
      };

      fetchQuote(WORKER_URL + '/pdp-quote', payload, function (data) {
        var ok = data && (data.specialOrder || (data.rates && data.rates.length));
        if (!ok) {
          if (!cachedData) showFallback(location);   // keep the cached result on screen if we have one
          return;
        }
        setCachedPdpResult(cacheK, data);
        // Re-render only if there was no cache shown or the fresh data differs (avoids flicker).
        if (!cachedData || JSON.stringify(cachedData) !== JSON.stringify(data)) {
          renderPdpResult(data, location);
        }
      });
    }

    setupAutocomplete(widget, function (loc) {
      saveLocation(loc);
      fetchEstimate(loc);
    });

    var productSection = widget.closest('[data-section-id]') || widget.closest('.shopify-section');

    // Keep the widget synced to the SELECTED variant. The old code waited for a plain 'variantChange'
    // event that this theme never fires (it uses the scoped 'variant:change:<section>:<product>', and
    // Swatch King uses 'wk:product:change-variant:success'), so the widget stayed frozen on the first
    // variant and quoted its box for every size (e.g. Grey always showed the 31cm rate). Instead we
    // re-read the current variant id from the product form's [name="id"] input, which the native
    // picker AND Swatch King both keep in sync, then look up its grams/sku/price from data-de-variants.
    var _deVariants = null;
    function variantMap() {
      if (_deVariants === null) {
        try { _deVariants = JSON.parse(widget.dataset.deVariants || '{}'); } catch (e) { _deVariants = {}; }
      }
      return _deVariants;
    }
    function currentVariantIdFromDom() {
      var scope = widget.closest('form') || productSection || document;
      var el = (scope && scope.querySelector('[name="id"]')) ||
               document.querySelector('form[action*="/cart/add"] [name="id"]') ||
               document.querySelector('[name="id"]');
      return el ? String(el.value || '') : '';
    }
    function syncVariant() {
      var newId = currentVariantIdFromDom();
      if (!newId || newId === String(widget.dataset.variantId)) return;
      widget.dataset.variantId = newId;
      var vd = variantMap()[newId];
      if (vd) {
        widget.dataset.sku = vd.sku || '';
        widget.dataset.grams = String(vd.grams || 0);
        widget.dataset.price = String(vd.price || 0);
        widget.dataset.inventoryQuantity = String(vd.inventory_quantity || 0);
        widget.dataset.inventoryPolicy = vd.inventory_policy || '';
      }
      var loc = getSavedLocation();
      if (loc) { fetchEstimate(loc); } else { updateDispatchNote('[data-de-prompt]'); }
    }

    // Native pickers and Swatch King both finish a variant change with [name="id"] updated and a
    // bubbling 'change'; the explicit Swatch King event is belt-and-braces. syncVariant() no-ops when
    // the id hasn't actually changed, so reacting to every 'change' is cheap.
    document.addEventListener('change', syncVariant);
    document.addEventListener('wk:product:change-variant:success', syncVariant);
    // Align once on load (e.g. a ?variant deep-link where the initial dataset differs from the form).
    syncVariant();

    function showPromptState() {
      showState(widget, 'prompt');
      updateDispatchNote('[data-de-prompt]');
    }

    var saved = getSavedLocation();
    if (saved) {
      fetchEstimate(saved);
    } else {
      // No saved location: try IP auto-detection before falling back to manual input.
      showState(widget, 'loading');
      detectLocation(function (loc) {
        if (loc) {
          saveLocation(loc, true);
          fetchEstimate(loc);
        } else {
          showPromptState();
        }
      });
    }
  }

  // ── Cart logic (blended order-level estimate) ──

  function initCart() {
    var container = document.querySelector('[data-cart-delivery-estimate]');
    if (!container) return;

    WORKER_URL = container.dataset.workerUrl || WORKER_URL;
    var currency = container.dataset.currency || 'AUD';

    var itemsScript = container.querySelector('[data-cart-items]');
    if (!itemsScript) return;
    var items;
    try { items = JSON.parse(itemsScript.textContent); } catch (e) { return; }
    if (!items.length) return;

    var jadcoSkus = ['BQ1700', 'BQ20', 'BQ368', 'MQ100-12HR', 'MQ100-24HR', 'R100-12HR', 'R100-24HR'];
    items.forEach(function (item) {
      item.out_of_stock = item.inventory_policy === 'continue' &&
        item.inventory_quantity < 1 &&
        jadcoSkus.indexOf(item.sku) !== -1;
    });

    var allSameDay = items.every(function (item) {
      return SAME_DAY_VENDORS.indexOf((item.vendor || '').toLowerCase()) !== -1 &&
        item.inventory_quantity > 0;
    });
    if (allSameDay) container.classList.add('cart-delivery-estimate--same-day');

    container.innerHTML =
      '<div data-cart-de-prompt>' +
        '<div class="de__heading de__heading--cart-free">FREE Shipping!</div>' +
        '<div class="de__body de__body--cart-sub">Enter your suburb or postcode for delivery estimates.</div>' +
        '<div class="de__input-wrap">' +
          '<input type="text" class="de__input" data-de-input placeholder="Suburb or postcode" autocomplete="off" aria-label="Enter suburb or postcode">' +
          '<ul class="de__suggestions" data-de-suggestions hidden></ul>' +
        '</div>' +
      '</div>' +
      '<div data-cart-de-loading hidden>' +
        '<div class="de__heading de__heading--cart-free">FREE Shipping!</div>' +
        '<div class="de__body de__skeleton">Loading delivery estimates...</div>' +
      '</div>' +
      '<div data-cart-de-result hidden></div>' +
      '<div data-cart-de-error hidden>' +
        '<div class="de__heading de__heading--cart-free">FREE Shipping!</div>' +
        '<div class="de__body">Couldn\'t load delivery options. Check again at checkout.</div>' +
      '</div>';

    function showCartState(state) {
      hide(container.querySelector('[data-cart-de-prompt]'));
      hide(container.querySelector('[data-cart-de-loading]'));
      hide(container.querySelector('[data-cart-de-result]'));
      hide(container.querySelector('[data-cart-de-error]'));
      show(container.querySelector('[data-cart-de-' + state + ']'));
    }

    function buildCartResultHtml(data, loc) {
      var chipLabel = escapeHtml(loc.suburb) + ' ' + escapeHtml(loc.state) + ' ' + escapeHtml(loc.postcode) +
        (loc.country === 'NZ' ? ' NZ' : '');

      var html = '<div class="de__heading"><span class="de__heading-emphasis">FREE Shipping</span> ' +
        '<span class="de__loc-group">to ' +
        '<button type="button" class="de__chip" data-cart-de-edit>' + chipLabel + '</button> ' +
        '<button type="button" class="de__edit-link" data-cart-de-edit>Change</button></span></div>';

      if (data.specialOrder) {
        html += '<div class="de__special-order">' + escapeHtml(data.specialOrder.message) + '</div>';
      }

      if (data.rates && data.rates.length) {
        var isFallback = data.rates[0] && data.rates[0].hideFallbackPrice;
        html += '<div class="de__rates">';
        sortRates(data.rates).forEach(function (rate) {
          html += buildRateHtml(rate);
        });
        html += '</div>';

        if (!isFallback) {
          var allQualify = items.every(function (item) {
            var v = (item.vendor || '').toLowerCase();
            return SAME_DAY_VENDORS.indexOf(v) !== -1 &&
              item.inventory_quantity > 0;
          });
          if (allQualify) {
            html += '<div class="de__cart-note">Order by 12pm AEST for same business-day dispatch</div>';
          }
          if (data.multipleSuppliers) {
            html += '<div class="de__cart-note">Items may arrive separately</div>';
          }
          if (loc.country !== 'NZ') {
            html += '<div class="de__cart-note">Choose Standard or Express at checkout</div>';
          }
        }
      }

      html += preorderNoteHtml(container, 'de__cart-note');

      return html;
    }

    function showCartFallback(loc) {
      var country = loc.country || 'AU';
      var note = country === 'NZ' ? FALLBACK_NOTE_NZ : FALLBACK_NOTE_AU;
      var chipLabel = escapeHtml(loc.suburb) + ' ' + escapeHtml(loc.state) + ' ' + escapeHtml(loc.postcode) +
        (country === 'NZ' ? ' NZ' : '');
      var fallback = STATIC_FALLBACK[country] || STATIC_FALLBACK.AU;
      var desc = fallback[0].description.replace(/<br>/g, '\n').split('\n');
      var html = '<div class="de__heading"><span class="de__heading-emphasis">FREE Shipping</span> ' +
        '<span class="de__loc-group">to ' +
        '<button type="button" class="de__chip" data-cart-de-edit>' + chipLabel + '</button> ' +
        '<button type="button" class="de__edit-link" data-cart-de-edit>Change</button></span></div>';
      html += '<div class="de__fallback-lines">';
      desc.forEach(function (line) { html += '<div class="de__fallback-line">' + line + '</div>'; });
      html += '</div>';
      html += '<div class="de__cart-note">' + note + '</div>';
      html += preorderNoteHtml(container, 'de__cart-note');
      var resultEl = container.querySelector('[data-cart-de-result]');
      resultEl.innerHTML = html;
      showCartState('result');
      fitCartLocGroup(container);
      var editBtns = resultEl.querySelectorAll('[data-cart-de-edit]');
      for (var i = 0; i < editBtns.length; i++) {
        editBtns[i].addEventListener('click', showPrompt);
      }
    }

    function fetchCartEstimate(loc) {
      showCartState('loading');

      var payload = {
        destination: {
          country: loc.country || 'AU',
          postal_code: loc.postcode,
          province: loc.state || '',
          city: loc.suburb || ''
        },
        items: items.map(function (i) {
          return {
            name: i.name, sku: i.sku, quantity: i.quantity, grams: i.grams,
            price: i.price, vendor: i.vendor, product_id: i.product_id,
            variant_id: i.variant_id, out_of_stock: i.out_of_stock
          };
        }),
        currency: currency
      };

      fetchQuote(WORKER_URL + '/cart-quote', payload, function (data) {
        if (!data || ((!data.rates || !data.rates.length) && !data.specialOrder)) {
          showCartFallback(loc);
          return;
        }

        var resultEl = container.querySelector('[data-cart-de-result]');
        resultEl.innerHTML = buildCartResultHtml(data, loc);
        showCartState('result');
        fitCartLocGroup(container);

        var editBtns = resultEl.querySelectorAll('[data-cart-de-edit]');
        for (var i = 0; i < editBtns.length; i++) {
          editBtns[i].addEventListener('click', showPrompt);
        }
      });
    }

    function showPrompt() {
      showCartState('prompt');
      var input = container.querySelector('[data-de-input]');
      if (input) { input.value = ''; input.focus(); }
    }

    setupAutocomplete(container, function (loc) {
      saveLocation(loc);
      fetchCartEstimate(loc);
    });

    // Re-fit the location cluster if the cart widget's width changes
    // (drawer open/close, orientation change, window resize).
    var resizeRaf = null;
    window.addEventListener('resize', function () {
      if (resizeRaf) return;
      resizeRaf = window.requestAnimationFrame(function () {
        resizeRaf = null;
        fitCartLocGroup(container);
      });
    });

    // Re-quote when the cart changes (qty change, protection toggle) so the
    // Express price/date reflect the new weight × quantity without a refresh.
    function rebuildItems(cartItems) {
      if (!cartItems || !cartItems.length) return false;
      var rebuilt = [];
      cartItems.forEach(function (ci) {
        if (!ci.requires_shipping) return;
        if (ci.product_type === 'Gift Cards') return;
        if ((ci.url || '').indexOf('navidium-shipping-protection') !== -1) return;
        var prev = null;
        for (var k = 0; k < items.length; k++) {
          if (items[k].variant_id === ci.variant_id) { prev = items[k]; break; }
        }
        rebuilt.push({
          name: ci.product_title || ci.title || '',
          sku: ci.sku || '',
          quantity: ci.quantity,
          grams: ci.grams,
          price: ci.original_price,
          vendor: ci.vendor || '',
          product_id: ci.product_id,
          variant_id: ci.variant_id,
          inventory_quantity: prev ? prev.inventory_quantity : 1,
          inventory_policy: prev ? prev.inventory_policy : ''
        });
      });
      if (!rebuilt.length) return false;
      rebuilt.forEach(function (item) {
        item.out_of_stock = item.inventory_policy === 'continue' &&
          item.inventory_quantity < 1 &&
          jadcoSkus.indexOf(item.sku) !== -1;
      });
      items = rebuilt;
      var allSameDayNow = items.every(function (item) {
        return SAME_DAY_VENDORS.indexOf((item.vendor || '').toLowerCase()) !== -1 &&
          item.inventory_quantity > 0;
      });
      container.classList.toggle('cart-delivery-estimate--same-day', allSameDayNow);
      return true;
    }

    var reQuoteTimer = null;
    document.addEventListener('cart:updated', function (e) {
      var cart = e && e.detail && e.detail.cart;
      clearTimeout(reQuoteTimer);
      reQuoteTimer = setTimeout(function () {
        var loc = getSavedLocation();
        if (!loc) return;
        function proceed(cartItems) {
          if (rebuildItems(cartItems)) fetchCartEstimate(loc);
        }
        if (cart && cart.items) {
          proceed(cart.items);
        } else {
          var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
          fetch(root + 'cart.js')
            .then(function (r) { return r.json(); })
            .then(function (c) { proceed(c.items); })
            .catch(function () { /* leave the current estimate in place */ });
        }
      }, 400);
    });

    var saved = getSavedLocation();
    if (saved) {
      fetchCartEstimate(saved);
    } else {
      // No saved location: try IP auto-detection before falling back to the manual prompt.
      showCartState('loading');
      detectLocation(function (loc) {
        if (loc) {
          saveLocation(loc, true);
          fetchCartEstimate(loc);
        } else {
          showCartState('prompt');
        }
      });
    }
  }

  // ── Init ──

  function init() {
    document.querySelectorAll('[data-delivery-estimate][data-context="pdp"]').forEach(initPdp);
    initCart();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
// EndCustomCode
